import { render, staticRenderFns } from "./TrafficLights.vue?vue&type=template&id=b91b5372&scoped=true&"
import script from "./TrafficLights.vue?vue&type=script&lang=js&"
export * from "./TrafficLights.vue?vue&type=script&lang=js&"
import style0 from "./TrafficLights.vue?vue&type=style&index=0&id=b91b5372&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91b5372",
  null
  
)

export default component.exports